import React from 'react'

function Drag_Drop({ color = 'black', bgColor = 'white' }) {
    return (
        <>
            <svg width="24" height="24" viewBox="0 0 24 24" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
                <path d="M7.5 3.5C5.9442 3.54667 5.01661 3.71984 4.37477 4.36227C3.49609 5.24177 3.49609 6.6573 3.49609 9.48836V15.9944C3.49609 18.8255 3.49609 20.241 4.37477 21.1205C5.25345 22 6.66767 22 9.49609 22H14.4961C17.3245 22 18.7387 22 19.6174 21.1205C20.4961 20.241 20.4961 18.8255 20.4961 15.9944V9.48836C20.4961 6.6573 20.4961 5.24177 19.6174 4.36228C18.9756 3.71984 18.048 3.54667 16.4922 3.5" stroke={color} />
                <path d="M7.49609 3.75C7.49609 2.7835 8.2796 2 9.24609 2H14.7461C15.7126 2 16.4961 2.7835 16.4961 3.75C16.4961 4.7165 15.7126 5.5 14.7461 5.5H9.24609C8.2796 5.5 7.49609 4.7165 7.49609 3.75Z" stroke={color} stroke-linejoin="round" />
                <path d="M13.5 11H17" stroke={color} stroke-linecap="round" />
                <path d="M7 12C7 12 7.5 12 8 13C8 13 9.58824 10.5 11 10" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
                <path d="M13.5 17H17" stroke={color} stroke-linecap="round" />
                <path d="M8 17H9" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
            </svg>
        </>
    )
}

export default Drag_Drop; 